// Components==============
import React from 'react';
import { TranslateType } from 'typings';
import Label from './Label';
import './Label.module.scss';
// =========================

export default function LabelWrapper({
  title,
  labels,
}: {
  title: TranslateType;
  labels?: string[];
}) {
  const localLabels = labels?.filter((exists) => exists);

  if (!localLabels?.length) return <></>;

  return (
    <div>
      <h2>{title}</h2>
      <div styleName="label-wrapper">
        {localLabels?.map((label) => (
          <Label size="large" type="outline" key={label}>
            {label}
          </Label>
        ))}
      </div>
    </div>
  );
}
